import { createAction } from "typesafe-actions";
import { ConstantsState } from "../@types/constants";


export const constantsActions = {
    set: createAction(
        '@constants/set',
        (constants: ConstantsState) => constants
    )(),
};